import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import LinkCell from '../Cells/LinkCell/LinkCell';
import ConnectionCell from '../Cells/ConnectionCell';
import DeviceLinkCell from '../Cells/LinkCell/DevicesLinkCall';
import BattaryCell from '../Cells/BattaryCell/BattaryCell';
import LocationLinkCell from '../Cells/LinkCell/LocationLinkCall';
import MiceAmountCell from '../Cells/MiceAmountCell/MiceAmountCell';
import { TrapTableTypeLink } from '../trapTables';

import ActionCell from 'components/TrapsTables/Cells/ActionCell/ActionCell';
import { MultiCatchTrapData } from 'api/traps/types';
import { Breakpoints } from 'hooks/Screen/useScreenSize';

export const useGetMultiCatchColumns = (slug: string): TableColumn<MultiCatchTrapData>[] => {
  const { t } = useTranslation();
  return [
    {
      name: <i className="ri-wifi-fill fs-16" />,
      selector: row => row.connection_status,
      sortable: true,
      sortField: 'connection_status',
      cell: row => <ConnectionCell status={row.connection_status} />,
      width: '75px',
    },
    {
      name: <i className="ri-battery-charge-fill fs-17" />,
      selector: row => row.battery_percentage,
      sortable: true,
      sortField: 'battery_percentage',
      cell: row => <BattaryCell percentage={row.battery_percentage || 0} />,
      width: '75px',
      style: { justifyContent: 'center' },
    },
    {
      name: <i className="ri-mickey-fill fs-15" />,
      selector: row => row.pest_amount,
      sortable: true,
      sortField: 'pest_amount',
      cell: row => <MiceAmountCell miceAmount={row.pest_amount || 0} title={row.time_from_last_activity} />,
      width: '75px',
      style: { justifyContent: 'start' },
    },
    {
      name: <div title={t('TrapTables.MCTNumberTooltip')}>{t('TrapTables.Number')}</div>,
      selector: row => row.sequence_number,
      sortable: true,
      sortField: 'sequence_number',
      cell: row => (
        <LinkCell
          title={row.sequence_number || 'None'}
          link={`/trap/mct/info/${row.slug}`}
          toReact
          icon="ri-eye-line"
        />
      ),
      grow: 1,
    },
    {
      name: t('TrapTables.InteractiveMap'),
      selector: row => row.default_plan?.url_ending || '',
      cell: row => (
        <DeviceLinkCell
          data={row.default_plan ?? null}
          icon="ri-treasure-map-line"
          slug={slug}
          deviceType={TrapTableTypeLink.MultiCatchMouseTraps}
          device_add_slug={row.slug}
        />
      ),
      grow: 2,
      hide: Breakpoints.Tablet,
    },
    {
      name: t('TrapTables.Location'),
      selector: row => row?.location?.title || '-',
      sortable: true,
      sortField: 'location__title',
      cell: _row => _row?.location?.title || <LocationLinkCell data={null} icon="ri-map-pin-line" slug={slug} />,
      grow: 2,
      hide: Breakpoints.Tablet,
    },
    {
      name: t('TrapTables.LastConnection'),
      selector: row => (row?.last_connect ? dayjs(row.last_connect).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm') : '-'),
      sortable: true,
      sortField: 'last_connect',
      hide: Breakpoints.Desktop,
    },
    {
      name: <div className=" pe-2">{t('TrapTables.Action')}</div>,
      selector: row => row.default_plan?.on_plan || '',
      hide: Breakpoints.Mobile,
      cell: row => (
        <ActionCell
          qrCodeOptions={{ msg: `Device Serial Number: ${row.serial_number}`, qr_code: row.qr_code }}
          trap={{ pk: row.id, serialNumber: row.serial_number }}
          slug={slug}
        />
      ),
      center: true,
    },
  ];
};
